import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PageContainerLayout from '@app/components/PageContainerLayout';
import getSirenEnabled from '@app/selectors/get-siren-enabled';
import getSirenIntevalOfFive from '@app/selectors/get-siren-interval-of-five';
import {
  muteSound,
  unmuteSound,
  soundWarningDismissed,
  soundPlayed,
  soundFailed,
} from '@app/actions/order-sound';
import { logout } from '@app/actions/user';

const PageContainer = props => {
  return <PageContainerLayout {...props} />;
};

const mapStateToProps = (state, ownProps) => {
  const {
    orderSound: { isSoundMuted, hasUserInteractedWithPage },
    auth: { userDisplayName },
  } = state;

  return {
    name: userDisplayName,
    isSoundMuted,
    isSoundEnabled: getSirenEnabled(state),
    soundIntervalOfFive: getSirenIntevalOfFive(state, ownProps),
    hasUserInteractedWithPage,
    withOldHeader: ownProps.withOldHeader,
    withFullWidth: ownProps.withFullWidth,
    withSidebar: ownProps.withSidebar,
  };
};
const actions = { logout, muteSound, unmuteSound, soundWarningDismissed, soundPlayed, soundFailed };
export default withRouter(
  connect(
    mapStateToProps,
    actions,
  )(PageContainer),
);



// WEBPACK FOOTER //
// ./src/containers/PageContainer.jsx